import { HighlighterProps } from '@/types/components/responseDialog';
import s from './ResponseDialog.module.css';

export const Highlighter = ({
    text,
    highlights,
    returnTextArea,
}: HighlighterProps) => {
    const segments = [];
    let prevIndex = 0;

    highlights.forEach(({ start, end }) => {
        if (start > prevIndex) {
            segments.push({
                text: text.slice(prevIndex, start),
                highlight: false,
            });
        }
        segments.push({ text: text.slice(start, end + 1), highlight: true });
        prevIndex = end + 1;
    });

    if (prevIndex < text.length) {
        segments.push({ text: text.slice(prevIndex), highlight: false });
    }

    function handleClick() {
        returnTextArea([]);
    }

    return (
        <div
            className={s['ResponseDialog__inputfield']}
            onClick={() => handleClick()}>
            {segments.map((segment, index) =>
                segment.highlight ? (
                    <mark key={index} className={s.ResponseDialog__highlight}>
                        {segment.text}
                    </mark>
                ) : (
                    <span key={index}>{segment.text}</span>
                )
            )}
        </div>
    );
};
